'use es6';

import { isEmpty } from 'underscore';
import { getFormThemes } from 'FormsUI/api/FormThemes';
import { getFormThemes as getFormThemesSelector } from 'FormsUI/selectors/FormThemes';
function createAction(name) {
  return `@@formThemes/${name}`;
}
export const REQUEST_THEMES = createAction('REQUEST_THEMES');
export const RECEIVE_THEMES = createAction('RECEIVE_THEMES');
export const SUCCEED_GETTING_THEMES = createAction('SUCCEED_GETTING_THEMES');
export const FAILED_GETTING_THEMES = createAction('FAILED_GETTING_THEMES');
function requestThemes() {
  return {
    type: REQUEST_THEMES
  };
}
function receiveThemes(receivedThemes) {
  return {
    type: RECEIVE_THEMES,
    themes: receivedThemes
  };
}
function succeedGettingThemes() {
  return {
    type: SUCCEED_GETTING_THEMES
  };
}
function failGettingThemes() {
  return {
    type: FAILED_GETTING_THEMES
  };
}
export function fetchFormThemes() {
  return (dispatch, getState) => {
    const cachedThemes = getFormThemesSelector(getState());
    if (!isEmpty(cachedThemes)) {
      return Promise.resolve();
    }
    dispatch(requestThemes());
    return getFormThemes().then(themes => {
      dispatch(succeedGettingThemes());
      dispatch(receiveThemes(themes));
    }).catch(error => {
      dispatch(failGettingThemes(error));
    });
  };
}